import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ConfirmModal from 'components/modals/ConfirmModal/ConfirmModal'

import messages from './messages'


class RedeemConfirmationModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
  }

  static defaultProps = {
    name: constants.modals.RedeemConfirmation,
  }

  confirm = () => {
    const { data: { onConfirm }, name } = this.props

    onConfirm()
    actions.models.modals.close(name)
  }

  close = () => {
    const { data: { onCancel }, name } = this.props

    onCancel()
    actions.models.modals.close(name)
  }

  render() {
    const { name, giftSubscription: { giverName, recipientEmail, months: monthsCount } } = this.props

    return (
      <ConfirmModal
        name={name}
        title={messages.title}
        confirmTitle={messages.confirmTitle}
        cancelTitle={messages.cancelTitle}
        onConfirm={this.confirm}
        onCancel={this.close}
      >
        <FormattedHTMLMessage {...messages.text} values={{ giverName, recipientEmail, monthsCount }} />
      </ConfirmModal>
    )
  }
}


export default connect({
  giftSubscription: 'models.me.giftSubscription',
})(RedeemConfirmationModal)
